import { httpClient } from './clients/httpClient'

export const getAvailableGeneralTicketsForEvent = async (eventId: string): Promise<any> => {
    try {
        const { data } = await httpClient.get(`/tickets/${eventId}/general`)
        return data
    } catch (error: any) {
        console.error('Error fetching general tickets:', error.response?.data || error.message)
        throw new Error('Failed to fetch tickets')
    }
}

export const lockNewTicketForUser = async (eventId: string, lockKey: string): Promise<string> => {
    try {
        const { data } = await httpClient.post(`/tickets/${eventId}/general/lock`, { sessionId: lockKey })
        return data.message
    } catch (error: any) {
        console.error('Error locking ticket:', error.response?.data || error.message)
        throw new Error('Failed to lock ticket')
    }
}

export const unlockATicketForUser = async (eventId: string, lockKey: string, amount: number = 1): Promise<string> => {
    try {
        const { data } = await httpClient.post(`/tickets/${eventId}/general/unlock`, { sessionId: lockKey, amount })
        return data.message
    } catch (error: any) {
        console.error('Error unlocking ticket:', error.response?.data || error.message)
        throw new Error('Failed to unlock ticket')
    }
}

export const getTicketsLockedByUser = async (eventId: string, lockKey: string): Promise<any[]> => {
    try {
        const { data } = await httpClient.post(`/tickets/${eventId}/general/currentUser`, { sessionId: lockKey })
        return data
    } catch (error: any) {
        console.error('Error fetching tickets locked by user:', error.response?.data || error.message)
        throw new Error('Failed to fetch tickets locked by user')
    }
}
